// Links to firebase account admin@vidatec.com
export default {
  apiKey: "AIzaSyBmTRiU6f8P6AvANPD-nE4iV0rbeyU7stU",
  authDomain: "engage-4---live.firebaseapp.com",
  projectId: "engage-4---live",
  storageBucket: "engage-4---live.firebasestorage.app",
  messagingSenderId: "38701566965",
  appId: "1:38701566965:web:382346a0c5d3b398666ebc",
  measurementId: "G-8R6VM9ZCV9"
};
